import styled from '@emotion/styled';

import { color } from '../style';

export const Caption = styled.span`
  display: block;
  font-size: 80%;
  color: ${color.text20};
  text-align: right;
`;
